// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"0396114e","326":"f234c3ef","753":"177a36ec"}[chunkId] + ".chunk.js";
};